React = require 'react'
_ = require 'underscore'
{ ActionHistory } = require '@trello/action-history'
Alerts = require 'app/scripts/views/lib/alerts'
ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
Dialog = require 'app/scripts/views/lib/dialog'
{ getSuggestionsFeedback } = require 'app/scripts/views/feedback/collectors/get-suggestions-feedback'
IdCache = require 'app/scripts/db/id-cache'
l = require 'app/scripts/lib/localize'
PopOver = require 'app/scripts/views/lib/pop-over'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
LabelLimitsErrorView = require 'app/scripts/views/label/label-limits-error-view'
SelectCardPosition = require 'app/scripts/views/card/select-card-position'
{ Storage } = require '@trello/storage'
View = require 'app/scripts/views/internal/view'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track, trackDebounced } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ MoveCardPopover } = require 'app/src/components/MoveCardPopover'

MAX_SUGGESTIONS = 5

tooManyCustomFieldsError = 'BOARD_TOO_MANY_CUSTOM_FIELDS'
tooManyCustomFieldOptionsError = 'CUSTOM_FIELD_TOO_MANY_OPTIONS'

module.exports = mixin SelectCardPosition, class CardMoveView extends View
  viewTitleKey: 'move card'

  initialize: ({ onCommit }) ->
    @onCommit = onCommit ? (->)
    @listenTo Auth.me().boardList, 'add remove reset', @render

  events:
    'change .js-select-position': 'renderValues'
    'change .js-select-list': 'updatePositionList'
    'change .js-select-board': 'updateBoardData'
    'click .js-submit': 'commitChange'
    'click .js-suggested-move': 'suggestedMove'
    'click .js-suggested-actions-feedback': getSuggestionsFeedback({ placement: 'Card Move' })

  render: ->
    data = {}
    currentBoard = @model.getBoard()
    enterprise = @model.getBoard().getEnterprise()

    # Don't allow guests on enterprise owned boards to move cards off the current board
    isGuest = currentBoard.isGuest(Auth.me())

    if isGuest && currentBoard.get('enterpriseOwned')
      data.isMove = true
      data.hasEnterprise = true
      data.enterpriseName = enterprise?.get('displayName')
      data.restrictToCurrentBoard = true
      data.organizations = [
        {
          displayName: currentBoard.getOrganization()?.get('displayName') || l('member boards.boards'),
          boards: [
            _.extend(currentBoard.toJSON(), { selected: true })
          ]
        }
      ]
    else if enterprise?
      data.isMove = true
      data.hasEnterprise = true
      currentBoard = if !@model.getBoard().getMembershipFor(Auth.me())? then currentBoard else null
      data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(true, enterprise.get('id'), currentBoard)
      data.enterpriseName = enterprise.get('displayName')
    else
      currentBoard = if @model.getBoard().isEditableByTeamMemberAndIsNotABoardMember() then currentBoard else null
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard)

    for org in data.organizations
      for board in org.boards
        if board.id == @model.get('idBoard')
          board.selected = true
          currentBoard = board

    data.suggestions = @getSuggestedMoves()

    partials =
      'move_card_controls': templates.move_card_controls

    if featureFlagClient.get('fep.nachos_select', false)
      renderComponent(React.createElement(MoveCardPopover, {
        organizations: data.organizations
        defaultBoardId: currentBoard.id
        defaultBoardName: currentBoard.name
        defaultListId: @model.getList().id
        defaultListName: @model.getList().get('name')
        cardList: @model.getList().cardList
        currentIndex: @model.getList().openCards().indexOf(@model)
        onSubmit: @requestChange.bind(@)
        hasEnterprise: data.hasEnterprise
        enterpriseName: data.enterpriseName
        restrictToCurrentBoard: data.restrictToCurrentBoard,
        isMove: data.isMove
        suggestions: @getSuggestedMoves()
      }), @$el.get(0))
    else
      partials =
        'move_card_controls': templates.move_card_controls

      @$el.html(
        templates.fill(
          require('app/scripts/views/templates/popover_move_card'),
          data,
          {},
          partials
        )
      )

    @updateBoardData()

    if data.suggestions.length > 0
      trackDebounced.hour("Suggestions", "Card Move Menu", "Displayed", data.suggestions.length)

    @

  getSuggestedMoves: ->
    history = ActionHistory.get()

    board = @model.getBoard()
    list = @model.getList()
    idList = @model.get('idList')
    idBoard = @model.get('idBoard')

    suggested = new Set()

    history.filter ({ action, context }) ->
      action.type == 'move' &&
      # Only move to places we've moved to from this list
      context.idList == idList &&
      # For now, restrict this to moves to other lists on the same board
      action.idBoard == idBoard
    .sort (a, b) ->
      # For two moves to the same target list,
      # prefer moves with an unambiguous target position
      if a.action.idList == b.action.idList
        aHasPosition = a.action.position != undefined
        bHasPosition = b.action.position != undefined
        if aHasPosition && !bHasPosition
          -1
        else if bHasPosition && !aHasPosition
          1
        else
          0
      else
        0
    .filter ({ action }) ->
      if suggested.has(action.idList)
        false
      else
        suggested.add(action.idList)
        true
    .filter ({ action }) => @model.isValidSuggestion(action, true)
    .slice(0, MAX_SUGGESTIONS)
    .map ({ action }) ->
      targetList = board.listList.get(action.idList)
      data = targetList.toJSON()
      data.direction =
        if targetList.get('pos') > list.get('pos') then 'right' else 'left'
      data.position = action.position
      data

  suggestedMove: (e) ->
    $target = @$(e.currentTarget)

    idList = $target.attr('data-id')
    listSelected = @model.getBoard().listList.get(idList)
    indexSelected =
      switch $target.attr('data-position')
        when 'top' then 0
        when '1' then 1
        else listSelected.cardList.length

    options = {
      $elem: $target,
      destinationList: listSelected,
    }

    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    @model.moveToList(listSelected, indexSelected)
    track("Card", "Suggested", "Move on Same Board")

    @onCommit()

    PopOver.hide()
    return

  commitChange: (e) ->
    $selectBoard = @$('.js-select-board')
    $selectList = @$('.js-select-list')
    $selectPos = @$('.js-select-position')

    idBoardSelected = $selectBoard.find('option:selected').val()
    idListSelected = $selectList.find('option:selected').val()
    posSelected = $selectPos.find('option:selected').val()
    indexSelected = parseInt($selectPos.find('option:selected').prop("index"), 10)

    @requestChange(e, idBoardSelected, idListSelected, posSelected, indexSelected)

  requestChange: (e, idBoardSelected, idListSelected, posSelected, indexSelected) ->
    if idBoardSelected == @model.getBoard().id
      listSelected = @model.getBoard().listList.get(idListSelected)
      options = {
        $elem: @$(e.target),
        destinationList: listSelected,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return

      @model.moveToList(listSelected, indexSelected)
      track("Card", "Move Menu", "Same Board")

    else if idBoardSelected? && idListSelected? && posSelected?
      boardSelected = @modelCache.get('Board', idBoardSelected)
      listSelected = boardSelected?.listList.get(idListSelected)
      options = {
        $elem: @$(e.target),
        hasChecklists: @model.checklistList.length > 0,
        hasAttachments: @model.attachmentList.length > 0,
        destinationBoard: boardSelected,
        destinationList: listSelected,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return
      hasLabels = @model.getLabels().length > 0
      if hasLabels && boardSelected.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

      track("Card", "Move Menu", "Changed Board")

      cardsInSelectedList = listSelected?.openCards().length
      @model.recordAction({
        type: 'move'
        idBoard: idBoardSelected
        idList: idListSelected
        position:
          # Only record a position if it's unambiguosly the top/bottom/1 position
          switch posSelected
            when 'top'
              if cardsInSelectedList > 0 then 'top' else undefined
            when 'bottom'
              if cardsInSelectedList > 1 then 'bottom' else undefined
            when '1'
              if cardsInSelectedList > 1 then 1 else undefined
            else undefined
      })

      @model.getList().cardList.remove(@model)
      # If we're showing a dialog (card detail) then hide it
      Dialog.hide()
      ApiAjax
        url: "/1/cards/#{ @model.id }"
        type: 'put'
        data: { idList: idListSelected, idBoard: idBoardSelected, pos: posSelected }
        success: (data) =>
          @model.board = null
          @model.set('idBoard', data.idBoard)
          @model.set('idList', data.idList)
          @model.set('pos', data.pos)
        error: (xhr) =>
          @model.getList().cardList.add(@model)
          error = xhr.responseJSON?.error
          if error == tooManyCustomFieldsError
            Alerts.show('too many custom fields card', 'error', 'moveerror', 8000)
          else if error == tooManyCustomFieldOptionsError
            Alerts.show('too many custom options card', 'error', 'moveerror', 8000)
          else
            Alerts.show('could not move card', 'error', 'moveerror', 5000)


    @onCommit()

    PopOver.hide()
    return
